import { render, staticRenderFns } from "./formDataSeller.vue?vue&type=template&id=c36b12da&scoped=true"
import script from "./formDataSeller.vue?vue&type=script&lang=js"
export * from "./formDataSeller.vue?vue&type=script&lang=js"
import style0 from "./formDataSeller.vue?vue&type=style&index=0&id=c36b12da&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36b12da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c36b12da')) {
      api.createRecord('c36b12da', component.options)
    } else {
      api.reload('c36b12da', component.options)
    }
    module.hot.accept("./formDataSeller.vue?vue&type=template&id=c36b12da&scoped=true", function () {
      api.rerender('c36b12da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/sellers/components/form/step/formDataSeller.vue"
export default component.exports